import React from 'react';
import './assets/css/main.css';
import { Link } from "react-router-dom";
import withRouter from './WithRouter';
import logo from './assets/img/logo.png'
import EmpProfile from "./EmpProfile/EmpProfile"
import EmpSchedule from "./EmpSchedule/EmpSchedule"
import EmpColleagues from "./EmpColleagues/EmpColleagues"

const UNAUTHED_TOKEN = "100001100011000011111010001000010";

//Перечисление секций, между которыми переключается окно выбора 1С
const OnecSections = {
	Selection: 1,
	Confirmation: 2
}

class EmpLogged extends React.Component {
    constructor(props) {
        super(props);

        this.state = { lname: "", fname: "", sname: "", email: "", tel: "", emp_id: 0, UID: "", profile: {}, loading: false, error_messages: [] };

        //Если пользователь авторизован как клиент, меняем страницу на главную
        if(localStorage.getItem('accessToken'))
            window.location = "/";

        //Если пользователь не авторизован, перенаправляем его на страницу входа
        if(!localStorage.getItem('empAccessToken'))
            window.location = "/emplogin";
    }

    componentDidMount() {
        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Счетчик обработанных запросов
        const requests_to_fetch = 1;
        let requests_processed = 0;

        fetch('/api/GetEmployeeUserInfo', {method: 'GET', headers:{'Content-Type': 'application/json', 'zr-emp-access-token': localStorage.getItem('empAccessToken')}})
            .then(response => response.json())
            .then(data => {
                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Выключаем анимацию загрузки, если все запросы обработаны
                    if(++requests_processed >= requests_to_fetch)
                        this.setState({loading: false});
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                    return;
                }

                //Проверяем флаг результата
                if(data.result)
                {
                    //Парсим данные
                    if('lname' in data.body && 'val' in data.body.lname)
                        this.setState({lname: data.body.lname.val});
                    if('fname' in data.body && 'val' in data.body.fname)
                        this.setState({fname: data.body.fname.val});
                    if('sname' in data.body && 'val' in data.body.sname)
                        this.setState({sname: data.body.sname.val});
                    if('email' in data.body && 'val' in data.body.email)
                        this.setState({email: data.body.email.val});
                    if('tel' in data.body && 'val' in data.body.tel)
                        this.setState({tel: data.body.tel.val});
                    if('emp_id' in data.body)
                        this.setState({emp_id: data.body.emp_id});
                    if('UID' in data.body)
                        this.setState({UID: data.body.UID});

                    //Запрашиваем профиль
                    fetch('/api/GetEmpProfile', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN},
                        body: JSON.stringify({ "empId": data.body.emp_id + "" })})
                        .then(response => response.json())
                        .then(data => {
                            //Проверяем наличие обязательных полей в ответе
                            if(!('result' in data) || !('body' in data))
                            {
                                //Выключаем анимацию загрузки, если все запросы обработаны
                                if(++requests_processed >= requests_to_fetch)
                                    this.setState({loading: false});
                                //Устанавливаем ошибку и прекращаем обработку
                                if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                    this.setState({error_messages: [...this.state.error_messages, "Получен некорректный ответ от сервера"]});
                                return;
                            }

                            //Проверяем флаг результата
                            if(data.result)
                            {
                                //Парсим данные
                                this.setState({profile: data.body});

                                //Запрашиваем аватар
                                fetch('/api/GetImageById', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': UNAUTHED_TOKEN},
                                    body: JSON.stringify({ "imgId": data.body.PICTURE })})
                                    .then(response => response.json())
                                    .then(data => {
                                        //Выключаем анимацию загрузки, если все запросы обработаны
                                        if(++requests_processed >= requests_to_fetch)
                                            this.setState({loading: false});

                                        //Проверяем наличие обязательных полей в ответе
                                        if(!('result' in data) || !('body' in data))
                                            return;
                                        else
                                        {
                                            //В случае ошибки добавляем ее в состояние
                                            if(!data.result)
                                            {
                                                //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                                                if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                                                {
                                                    localStorage.removeItem('empAccessToken');
                                                    window.location = "/emplogin";
                                                }
                                            }
                                            else
                                            {
                                                if(!('base64data' in data.body))
                                                    return;

                                                //Парсим данные
                                                let profile = this.state.profile;
                                                profile.avatar = data.body.base64data;
                                                this.setState({profile: profile});
                                            }
                                        }
                                    })
                                    .catch((error) => {
                                        //Выключаем анимацию загрузки, если все запросы обработаны
                                        if(++requests_processed >= requests_to_fetch)
                                            this.setState({loading: false});
                                    });
                            }
                            else
                            {
                                //Выключаем анимацию загрузки, если все запросы обработаны
                                if(++requests_processed >= requests_to_fetch)
                                    this.setState({loading: false});
                                //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                                if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                                {
                                    localStorage.removeItem('empAccessToken');
                                    window.location = "/emplogin";
                                }
                            }
                        })
                        .catch((error) => {
                            //Выключаем анимацию загрузки, если все запросы обработаны
                            if(++requests_processed >= requests_to_fetch)
                                this.setState({loading: false});
                            //Устанавливаем ошибку
                            if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
                        });
                }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.setState({error_messages: [...this.state.error_messages, "Ошибка получения ответа от сервера"]});
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.router.location.pathname === "/empschedule")
            document.title = "Расписание сотрудника - Здоровый ребенок";
        else if(this.props.router.location.pathname === "/empprofile")
            document.title = "Профиль сотрудника - Здоровый ребенок";
        else if(this.props.router.location.pathname === "/empcolleagues")
            document.title = "Список сотрудников - Здоровый ребенок";
    }

    render() {
        return (
            <>
                {this.state.loading &&
                <div class="pre-loader">
                    <div class="loader-spinner">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                }

                <header>
                    <div class="container flex-row align-center">
                        <a href="/empschedule" class="logo">
                            <img src={logo}></img>
                        </a>
                        <div class="person">
                            {this.state.profile.avatar && this.state.profile.avatar.length > 0 && <a href="/empprofile" class="person--photo" style={{backgroundImage: `url(data:image/jpeg;base64,${this.state.profile.avatar})`}}></a>}
                            {(!this.state.profile.avatar || this.state.profile.avatar.length === 0) && <a href="/empprofile"><span class="person--photo-null">
                                    {((this.state.lname.length > 0) ? this.state.lname.charAt(0) : 'X') +
                                     ((this.state.fname.length > 0) ? this.state.fname.charAt(0) : 'Y')}
                                    </span></a>}
                            <a href="/empprofile" class="person--name">
                                {this.state.lname + " " + this.state.fname + " " + this.state.sname}
                            </a>
                            <a href="#" class="person--logout" onClick={(e) => {localStorage.removeItem('empAccessToken'); this.props.router.navigate("/emplogin");}}>
                                Выход
                            </a>
                        </div>
                        <div class="mobile-menu-icon">
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 14.0007C0 13.3563 0.696445 12.834 1.55555 12.834L26.4444 12.834C27.3036 12.834 28 13.3563 28 14.0007C28 14.645 27.3036 15.1673 26.4444 15.1673L1.55555 15.1673C0.696445 15.1673 0 14.645 0 14.0007Z" fill="#D30D15"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.66667C0 4.02233 0.696445 3.5 1.55555 3.5L26.4444 3.5C27.3036 3.5 28 4.02233 28 4.66667C28 5.311 27.3036 5.83333 26.4444 5.83333L1.55555 5.83333C0.696445 5.83333 0 5.311 0 4.66667Z" fill="#D30D15"/>
                                <path d="M0 23.3327C0 22.6884 0.696445 22.166 1.55555 22.166H26.4444C27.3036 22.166 28 22.6884 28 23.3327C28 23.977 27.3036 24.4993 26.4444 24.4993H1.55555C0.696445 24.4993 0 23.977 0 23.3327Z" fill="#D30D15"/>
                            </svg>
                        </div>
                    </div>
                </header>
                <div class="mobile-menu">
                    <div class="container mobile-menu--inner">
                        <div class="mobile-menu--top">
                            <div class="mobile-menu--logo">
                                <a href="/empschedule">
                                    <img src={logo}></img>
                                </a>
                            </div>
                            <div class="mobile-menu--close">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.16699 22.8346L22.6159 1.38573M1.16699 1.16797L22.6159 22.6169" stroke="#D30D15" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <ul>
                            <li class={this.props.router.location.pathname === "/empschedule" ? "selected" : ""} onClick={(e) => document.querySelector('.mobile-menu--close').click()}><Link to={"/empschedule"}>Моё расписание</Link></li>
                            <li class={this.props.router.location.pathname === "/empprofile" ? "selected" : ""} onClick={(e) => document.querySelector('.mobile-menu--close').click()}><Link to={"/empprofile"}>Мой профиль</Link></li>
                            <li class={this.props.router.location.pathname === "/empcolleagues" ? "selected" : ""} onClick={(e) => document.querySelector('.mobile-menu--close').click()}><Link to={"/empcolleagues"}>Мои коллеги</Link></li>
                        </ul>
                        <a href="#" class="person--logout" onClick={(e) => {localStorage.removeItem('empAccessToken'); this.props.router.navigate("/emplogin");}}>
                            Выход из профиля
                        </a>
                    </div>
                </div>
                <main>
                    <div class="content">
                        <div class="container flex">
                            <div class="side-bar">
                                <ul class="side-bar--menu">
                                    <li class={this.props.router.location.pathname === "/empschedule" ? "selected" : ""}><Link to={"/empschedule"}>Моё расписание</Link></li>
                                    <li class={this.props.router.location.pathname === "/empprofile" ? "selected" : ""}><Link to={"/empprofile"}>Мой профиль</Link></li>
                                    <li class={this.props.router.location.pathname === "/empcolleagues" ? "selected" : ""}><Link to={"/empcolleagues"}>Мои коллеги</Link></li>
                                </ul>
                            </div>
                            <div class="side-content">
                                {this.props.router.location.pathname === "/empschedule" &&
                                <EmpSchedule lname={this.state.lname} fname={this.state.fname} sname={this.state.sname} email={this.state.email} tel={this.state.tel}
                                            emp_id={this.state.emp_id} UID={this.state.UID} profile={this.state.profile} error_messages={this.state.error_messages}
                                            update_error_messages_callback={(errors) => this.setState({error_messages: errors})}/>
                                }
                                {this.props.router.location.pathname === "/empprofile" &&
                                <EmpProfile lname={this.state.lname} fname={this.state.fname} sname={this.state.sname} email={this.state.email} tel={this.state.tel}
                                            emp_id={this.state.emp_id} UID={this.state.UID} profile={this.state.profile} error_messages={this.state.error_messages}
                                            update_error_messages_callback={(errors) => this.setState({error_messages: errors})}/>
                                }
                                {this.props.router.location.pathname === "/empcolleagues" &&
                                <EmpColleagues error_messages={this.state.error_messages} update_error_messages_callback={(errors) => this.setState({error_messages: errors})}
                                               router={this.props.router}/>
                                }
                            </div>
                        </div>
                    </div>
                </main>
                <div class="bottom-menu">
                    <div class="container">
                        <div class="bottom-menu--list">
                            <a href="/empschedule">
                                <span class="icon">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.5 8.7V23.5C24.5 23.7652 24.3946 24.0196 24.2071 24.2071C24.0196 24.3946 23.7652 24.5 23.5 24.5H2C1.73478 24.5 1.48043 24.3946 1.29289 24.2071C1.10536 24.0196 1 23.7652 1 23.5V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H17.57" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M6.48965 16.1358L6.16965 18.9308C6.1626 18.9931 6.16961 19.0562 6.19016 19.1155C6.21071 19.1748 6.24428 19.2287 6.28841 19.2733C6.33253 19.3179 6.38608 19.3521 6.44513 19.3733C6.50419 19.3945 6.56724 19.4021 6.62965 19.3958L9.40965 19.0758C9.50384 19.0641 9.59164 19.022 9.65965 18.9558L24.1996 4.36077C24.2769 4.28368 24.3382 4.1921 24.38 4.09129C24.4218 3.99048 24.4434 3.88241 24.4434 3.77327C24.4434 3.66413 24.4218 3.55606 24.38 3.45525C24.3382 3.35444 24.2769 3.26287 24.1996 3.18577L22.3246 1.30077C22.1681 1.14445 21.9559 1.05664 21.7347 1.05664C21.5134 1.05664 21.3012 1.14445 21.1447 1.30077L6.60465 15.8908C6.54001 15.9573 6.49953 16.0435 6.48965 16.1358Z" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M19.1855 3.26953L22.2005 6.36953" stroke="#D30D15" stroke-width="2"/>
                                    </svg>
                                </span>
                                расписание
                            </a>
                            <a href="/empprofile">
                                <span class="icon">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 13.5C15.7614 13.5 18 11.2614 18 8.5C18 5.73858 15.7614 3.5 13 3.5C10.2386 3.5 8 5.73858 8 8.5C8 11.2614 10.2386 13.5 13 13.5Z" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M4.5 22.5C4.5 19.5 6.5 16.5 13 16.5C19.5 16.5 21.5 19.5 21.5 22.5" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M1 23.5C1 23.7652 1.10536 24.0196 1.29289 24.2071C1.48043 24.3946 1.73478 24.5 2 24.5H24C24.2652 24.5 24.5196 24.3946 24.7071 24.2071C24.8946 24.0196 25 23.7652 25 23.5V2.5C25 2.23478 24.8946 1.98043 24.7071 1.79289C24.5196 1.60536 24.2652 1.5 24 1.5H2C1.73478 1.5 1.48043 1.60536 1.29289 1.79289C1.10536 1.98043 1 2.23478 1 2.5V23.5Z" stroke="#D30D15" stroke-width="2"/>
                                    </svg>
                                </span>
                                профиль
                            </a>
                            <a href="/empcolleagues">
                                <span class="icon">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 10.5C10.6569 10.5 12 9.15685 12 7.5C12 5.84315 10.6569 4.5 9 4.5C7.34315 4.5 6 5.84315 6 7.5C6 9.15685 7.34315 10.5 9 10.5Z" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M17 10.5C18.6569 10.5 20 9.15685 20 7.5C20 5.84315 18.6569 4.5 17 4.5C15.3431 4.5 14 5.84315 14 7.5C14 9.15685 15.3431 10.5 17 10.5Z" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M4.5 19.5C4.5 17.5 6 15.5 9 15.5C12 15.5 13.5 17.5 13.5 19.5" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M13.5 19.5C13.5 17.5 15 15.5 18 15.5C21 15.5 22.5 17.5 22.5 19.5" stroke="#D30D15" stroke-width="2"/>
                                        <path d="M1 23.5C1 23.7652 1.10536 24.0196 1.29289 24.2071C1.48043 24.3946 1.73478 24.5 2 24.5H24C24.2652 24.5 24.5196 24.3946 24.7071 24.2071C24.8946 24.0196 25 23.7652 25 23.5V2.5C25 2.23478 24.8946 1.98043 24.7071 1.79289C24.5196 1.60536 24.2652 1.5 24 1.5H2C1.73478 1.5 1.48043 1.60536 1.29289 1.79289C1.10536 1.98043 1 2.23478 1 2.5V23.5Z" stroke="#D30D15" stroke-width="2"/>
                                    </svg>
                                </span>
                                коллеги
                            </a>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(EmpLogged);
